export default "__VITE_ASSET__KHIwFWa4__"